// Mobile header navigation sheet: one link list renders inline from md up and as a full-screen sheet below md.
class SHeaderNav extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.syncGroups();
    // Mega stage: hovering or focusing a collection entry shows its model photo slide.
    const showSlide = (event) => {
      const entry = event.target.closest?.('[data-mega-i]');
      if (!entry) return;
      const stage = this.querySelector('[data-mega-stage]');
      if (!stage) return;
      stage.querySelectorAll('[data-mega-slide]').forEach((slide) => {
        slide.toggleAttribute('data-on', slide.dataset.megaSlide === entry.dataset.megaI);
      });
    };
    this.addEventListener('pointerover', showSlide, { signal });
    this.addEventListener('focusin', showSlide, { signal });
    // Mobile sheet: picking a country/currency submits Shopify's localization form right away.
    this.addEventListener('change', (event) => {
      const select = event.target.closest?.('select[data-auto-submit]');
      select?.form?.requestSubmit();
    }, { signal });

    window.matchMedia('(min-width: 48rem)').addEventListener('change', () => this.syncGroups(), { signal });

    this.addEventListener(
      'command',
      (event) => {
        if (event.command === '--toggle') this.setOpen(!this.hasAttribute('open'));
        if (event.command === '--close') this.setOpen(false);
      },
      { signal }
    );

    this.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.setOpen(false);
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  // Collection groups (<details data-menu-group>) collapse behind a + in the mobile sheet; from md up they are always open in the dropdown.
  syncGroups() {
    const desktop = window.matchMedia('(min-width: 48rem)').matches;
    this.querySelectorAll('details[data-menu-group]').forEach((group) => {
      group.open = desktop;
    });
  }

  get toggleButtons() {
    return this.ownerDocument.querySelectorAll(`[commandfor="${this.id}"][command="--toggle"]`);
  }

  setOpen(open) {
    this.toggleAttribute('open', open);
    this.ownerDocument.documentElement.classList.toggle('overflow-hidden', open);
    this.toggleButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));

    if (open) {
      this.querySelector('a')?.focus();
    } else {
      this.toggleButtons[0]?.focus();
    }
  }
}

if (!customElements.get('s-header-nav')) customElements.define('s-header-nav', SHeaderNav);
